import * as React from 'react';

const Pencil12 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", width: 12, height: 12, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m7.5 2.55 2 1.95 1.2-1.2a1 1 0 0 0 0-1.42l-.58-.59a1 1 0 0 0-1.41 0zm1 2.95L2.98 11H1V9l5.5-5.5z" }));
Pencil12.Size = 12;
Pencil12.Title = "Pencil";

export { Pencil12 as default };
